import { Component, Input } from '@angular/core';

import { Poll } from 'rev-portal/scheduledEvents/polls/Poll';
import { IPollAnswer, PollGraphType } from 'rev-portal/scheduledEvents/polls/Polls.Contract';

let pollCardIndex = 0;
@Component({
	selector: 'vb-poll-card',
	template: ''
})
export class VbPollCardComponent {
	@Input() public poll: Poll;

	private preferredView = PollGraphType.BAR;

	protected readonly PollGraphType = PollGraphType;
	protected cardIndex = ++pollCardIndex;

	protected getPercent(answer: IPollAnswer): string {
		if (answer.count == null || answer.count === 0) {
			return '0%';
		}
		return ((answer.count / this.poll.totalResponses) * 100).toFixed(1) + '%';
	}

	protected getModeratorView(poll: Poll): PollGraphType {
		return poll.multipleChoice ? PollGraphType.BAR : this.preferredView;
	}

	protected getAttendeeView(poll: Poll): PollGraphType {
		return !poll.isPublished ? PollGraphType.NONE : this.getModeratorView(poll);
	}

	protected setBarGraph(): void {
		this.preferredView = PollGraphType.BAR;
	}

	protected setPieGraph(): void {
		this.preferredView = PollGraphType.PIE;
	}
}
